import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { uil_is_object_fixed } from '../../ui_logic';
import { shift_pressed } from '../../keypress';
import fix_svg from '../../../assets/img/SVG_icons/Top/create_model/anchor.svg';
import { img } from '@phi/components';
import { uid_set_fixing_of_selected_objects } from '@frontend/ui_display';
import FixObjectsTooltip from './FixTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const FixIcon = fix_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Fix objects';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_sketches
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_stl
                || this.total_selected_objects === 0
                || this.state.rigid_move_manipulator;
        },

        total_selected_objects() {
            return this.state.selected_edges_count
                + this.state.selected_faces_count
                + this.state.selected_vertices_count;
        },

        selected_object_is_fixed() {
            this.total_selected_objects;
            if (!uid_selected_edges || !uid_selected_faces || !uid_selected_vertices)
                return false;
            else return [
                ...uid_selected_edges.keys(),
                ...uid_selected_faces.keys(),
                ...uid_selected_vertices.keys(),
            ].every(uil_is_object_fixed);
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.selected_object_is_fixed)
                uid_set_fixing_of_selected_objects(false);
            else
                uid_set_fixing_of_selected_objects(true && !shift_pressed());
        },

        onLongClick() {
            if (this.disabled)
                return;
            else
                uid_set_fixing_of_selected_objects(false);
        },
    },

    render() {
        return h(BarButton, {
            id: 'fix-objects-button',
            wrapperId: 'fix-objects-wrapper',
            long: true,
            onClick: this.onClick,
            onLongClick: this.onLongClick,
            disabled: this.disabled,
            selected: this.state.tut_stage === 6,
            active: this.selected_object_is_fixed,
            tippy: 'bottom',
            help: 'fix_objects',
        }, {
            label: () => 'Fix',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(fix_svg, this.alt),
            tooltip: FixObjectsTooltip,
        });
    },
});
